import { FontWeight, ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      alignSelf: 'flex-end',
      marginRight: 'auto',
      color: 'var(--x-text-color-6)',
      fontSize: 12,
      lineHeight: '20px',
      fontWeight: FontWeight.SemiBold,

      [mediaQuery(breakpoints.mobile)]: {
        flexBasis: '100%',
        marginBottom: '2px',
      },
    },
  }),
  { name: 'WordCount' },
);
export default useStyles;
